import { Grid } from '@mui/material'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import SelectCustom from '../../atoms/select/SelectCustom'

const HairStylist = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Hair Stylist Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactNumber"
								className={styles.label}
							>
								Company Contact Number
							</label>
							<InputCustom
								id="companyContactNumber"
								name="companyContactNumber"
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="gettingReadyLocation"
								className={styles.label}
							>
								Getting ready location
							</label>
							<InputCustom
								id="gettingReadyLocation"
								name="gettingReadyLocation"
								placeholder="Enter getting ready location"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfPeopleGettingHairDone"
								className={styles.label}
							>
								Number of people getting hair done
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Bride(s)', label: 'Bride(s)' },
									{
										value: 'Bridesmaids',
										label: 'Bridesmaids',
									},
									{
										value: 'Familymembers/others',
										label: 'Family members/others',
									},
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfStylistsOnTeam"
								className={styles.label}
							>
								Number of stylists on team
							</label>
							<InputCustom
								id="numberOfStylistsOnTeam"
								name="numberOfStylistsOnTeam"
								placeholder="Enter number of stylists on team"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Schedule Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="estimatedTimePerAdditionalPerson"
								className={styles.label}
							>
								Estimated time for (enter bride’s preferred
								name)
							</label>
							<InputCustom
								id="estimatedTimeForBride"
								name="estimatedTimeForBride"
								placeholder="Enter estimated time for (enter bride’s preferred name)"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="estimatedTimePerAdditionalPerson"
								className={styles.label}
							>
								Estimated time per additional person
							</label>
							<InputCustom
								id="estimatedTimePerAdditionalPerson"
								name="estimatedTimePerAdditionalPerson"
								placeholder="Enter estimated time per additional person"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label htmlFor="startTime" className={styles.label}>
								Start time
							</label>
							<InputCustom
								id="startTime"
								name="startTime"
								placeholder="Enter start time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="completionTime"
								className={styles.label}
							>
								Completion time
							</label>
							<InputCustom
								id="completionTime"
								name="completionTime"
								placeholder="Enter completion time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="touchUpsIncluded"
								className={styles.label}
							>
								Touch ups included?
							</label>
							<SelectCustom
								id="touchUpsIncluded"
								name="touchUpsIncluded"
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="whenAreTouchUpsScheduled"
								className={styles.label}
							>
								When are touch ups scheduled?
							</label>
							<InputCustom
								id="whenAreTouchUpsScheduled"
								name="whenAreTouchUpsScheduled"
								placeholder="Enter when are touch ups scheduled?"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="travelRequired"
								className={styles.label}
							>
								Travel required?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="coordinationWithMakeupArtist"
								className={styles.label}
							>
								Coordination with makeup artist?
							</label>
							<SelectCustom
								id="coordinationWithMakeupArtist"
								name="coordinationWithMakeupArtist"
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="willTouchUpsBeNeededBeforeCeremonyPhotos"
								className={styles.label}
							>
								Will touch-ups be needed before ceremony/photos?
							</label>
							<InputCustom
								id="willTouchUpsBeNeededBeforeCeremonyPhotos"
								name="willTouchUpsBeNeededBeforeCeremonyPhotos"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingencyOrSetupChangeNeeded"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingencyOrSetupChangeNeeded"
								name="rainContingencyOrSetupChangeNeeded"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupTeardownDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupTeardownDuration"
								name="setupTeardownDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipmentOrSpaceNeeds"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipmentOrSpaceNeeds"
								name="specialEquipmentOrSpaceNeeds"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default HairStylist
